import colors from '@rategravity/frontend/theme/colors';
import Paper from 'material-ui/Paper';
import PropTypes from 'prop-types';
import React from 'react';
import CompleteButton from './complete-button';
import NextButton from './next-button';

const style = {
  paper: {
    maxWidth: 720,
    margin: 'auto',
    boxShadow: 'unset'
  },
  content: {
    padding: '4%'
  },
  title: {
    color: colors.primary,
    fontSize: '24px',
    lineHeight: '1.25em'
  },
  footer: {
    marginTop: 30,
    textAlign: 'center'
  }
};

const Footer = ({ complete, onSubmit, closeInfo, buttonType, completeText }) => {
  switch (buttonType) {
    case 'complete':
      return (
        <div style={style.footer}>
          <CompleteButton
            disabled={!complete}
            completeText={completeText}
            onSubmit={() => {
              closeInfo();
              return onSubmit();
            }}
          />
        </div>
      );
    case 'none':
      return null;
    default:
      return (
        <div style={style.footer}>
          <NextButton
            disabled={!complete}
            onSubmit={() => {
              closeInfo();
              return onSubmit();
            }}
          />
        </div>
      );
  }
};

class Card extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  render() {
    const {
      title,
      info: Info,
      onSubmit,
      complete,
      children,
      buttonType,
      completeText = 'SUBMIT QUESTIONNAIRE',
      actionPipe
    } = this.props;
    const footerProps = {
      complete,
      onSubmit,
      closeInfo: () => this.setState({ open: false }),
      buttonType,
      completeText
    };
    return (
      <Paper style={style.paper}>
        <div style={style.content}>
          <h3 style={style.title}>{title}</h3>
          {children}
          {Info ? <Info actionPipe={actionPipe} /> : null}
          {onSubmit ? <Footer {...footerProps} /> : null}
        </div>
      </Paper>
    );
  }
}

Card.propTypes = {
  complete: PropTypes.bool,
  onSubmit: PropTypes.func,
  info: PropTypes.func
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/card/index.js